import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { StorageService } from './storage.service';
import { localStorageKey } from 'src/app/utils/metareducers/storage.metareducer';
import { environment } from 'src/environments/environment';
import { CookieService } from 'ngx-cookie-service';
import { Observable } from 'rxjs/Observable';
import { ILogin } from '../interfaces/login';
import { from } from 'rxjs';
import { RequestsServices } from './requests.service';

@Injectable({
  providedIn: 'root',
})
export class AuthService {
  baseUrl = 'customers';

  constructor(
    private http: HttpClient,
    private storage: StorageService,
    private cookieService: CookieService,
    private request: RequestsServices
  ) {}

  me() {
    return from(this.request.get({path: 'customers', endPoint: '/me'}));
  }

  updateMe(data: any) {
    return from(this.request.put('customers', data, '', '/me'));
  }

  loginWithDirectToken(params: any): Observable<ILogin> {
    return this.http.get<ILogin>('tokendirectlogins/login-by-token', {
      params,
    });
  }

  login(params: any): Observable<ILogin> {
    return this.http.post<ILogin>(`${this.baseUrl}/login`, params);
  }

  logout(nextParam?, redirect = true) {
    const privacity = 'privacidade';
    const next =
      nextParam && !['/', '/logout'].includes(nextParam)
        ? `&next=${nextParam}`
        : '';
    this.storage.clear();
    this.storage.removeExternal(localStorageKey);
    this.cookieService.deleteAll('/', environment.COOKIE_DOMAIN);
    this.cookieService.delete('page', privacity);

    if (redirect) {
      window.location.href = `${environment.SITE_URL}entrar?cl=true${next}`;
    }
  }
}
